export default "./dist/stdassets/cursors/grabbing.cur";